import { Component, input, InputSignal, output } from '@angular/core';
import { FormioForm, FormioModule } from '@formio/angular';
import { get } from 'lodash';
import {
  selectBoxesBuilderConfig,
  textFieldBuilderConfig,
  TFormioOptions,
} from '../../../core/constants/scw-formio.constants';

@Component({
  imports: [FormioModule],
  selector: 'app-scw-formio-builder',
  styleUrls: ['../scw-formio/scw-formio.component.scss', './scw-formio-builder.component.scss'],
  templateUrl: './scw-formio-builder.component.html',
})
export class ScwFormioBuilderComponent {
  public disabledForm: InputSignal<boolean | undefined> = input<boolean>();

  protected readonly formIoConfiguration: TFormioOptions | undefined = {
    noDefaultSubmitButton: true,
    builder: {
      basic: {
        title: 'Basic',
        weight: 0,
        default: true,
        components: {
          button: false,
          password: false,
          textfield: {
            documentation: 'http://help.form.io/userguide/#textfield',
            group: 'basic',
            icon: 'terminal',
            key: 'textfield',
            schema: {
              allowCalculateOverride: false,
              allowMultipleMasks: false,
              attributes: {},
              autofocus: true,
              calculateServer: false,
              calculateValue: '',
              clearOnHide: true,
              conditional: {
                eq: '',
                show: null,
                when: null,
              },
              customClass: '',
              customDefaultValue: '',
              dbIndex: false,
              defaultValue: null,
              description: '',
              disabled: false,
              encrypted: false,
              errorLabel: '',
              hidden: false,
              hideLabel: false,
              input: true,
              inputFormat: 'plain',
              inputMask: '',
              inputType: 'text',
              key: 'textField',
              label: 'TextField',
              labelPosition: 'top',
              mask: false,
              modalEdit: false,
              multiple: false,
              overlay: {
                height: '',
                left: '',
                style: '',
                top: '',
                width: '',
              },
              persistent: true,
              placeholder: '',
              prefix: '',
              properties: {},
              protected: false,
              redrawOn: '',
              refreshOn: '',
              showCharCount: false,
              showWordCount: false,
              spellcheck: true,
              suffix: '',
              tabindex: '',
              tableView: true,
              tooltip: '',
              type: 'textfield',
              unique: false,
              validate: {
                custom: '',
                customPrivate: false,
                maxLength: '',
                minLength: '',
                multiple: false,
                pattern: '',
                required: false,
                strictDateValidation: false,
                unique: false,
              },
              validateOn: 'change',
              widget: {
                type: 'input',
              },
            },
            title: 'Text Field',
            weight: 0,
          },
        },
      },
      advanced: false,
      layout: {
        title: 'Layout',
        weight: 20,
        components: {
          well: false,
          tabs: false,
          fieldset: false,
          htmlelement: false,
        },
      },
      data: false,
      premium: false,
    },
    editForm: {
      textfield: textFieldBuilderConfig,
      textarea: textFieldBuilderConfig,
      number: textFieldBuilderConfig,
      checkbox: textFieldBuilderConfig,
      selectboxes: selectBoxesBuilderConfig,
      select: selectBoxesBuilderConfig,
      radio: selectBoxesBuilderConfig,
    },
  };
  public readonly initialForm = input<FormioForm>();
  public editedForm = output<FormioForm>();

  public handleChangeClick(event: object): void {
    const form: FormioForm | undefined = get(event, 'form');

    if (form) {
      this.editedForm.emit(form);
    }
  }
}
